import React from 'react';
import { t, translate } from 'react-switch-lang';

function InfoCopyField({
  label,
  value,
  copied,
  onCopyClick,
  preventBrowserTranslate,
}) {
  return (
    <>
      <div className="copyInfoFieldContainer">
        <p className="copyInfoFieldLabel">
          {(label)}
        </p>
        <button
          className="copyInfoField copyButtonStyle"
          onClick={() => { onCopyClick(value, label); }}
          type="button"
          title={t('ButtonTitle_Copy').replace('xLabel', label)}
          aria-label={t('ButtonDescription_CopyDetails').replace('xField', label).replace('xValue', value)}
        >
          <div className="copyInfoFieldValueContainer">
            <p translate={preventBrowserTranslate ? 'no' : undefined} data-testid={label}>
              {(value)}
            </p>
            <div className="copyTextContainer">
              <p className="copyText">{copied === label ? t('Instructions_InteraceTransfer_V2_Copied') : t('Instructions_InteraceTransfer_V2_Copy')}</p>
            </div>
          </div>
        </button>
      </div>
    </>
  );
}

export default translate(InfoCopyField);
